/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Moon(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 19 18" fill="none" height={size} width={size} {...other}>
      <path
        d="M16 1.5V5.5M18 3.5H14M16.407 11.999C15.212 14.915 12.349 16.97 9.002 16.97C4.583 16.971 1 13.388 1 8.968C1 4.782 4.215 1.352 8.31 1C6.271 3.806 6.509 7.751 9.039 10.281C11.033 12.275 13.905 12.842 16.407 11.999Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Moon.defaultProps = {
  color: "currentColor",
  size: 24,
};

Moon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
